<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="faq">
    <HeroSingle :content="content.hero"></HeroSingle>

    <div class="wrapper">
      <div class="faq-inner">
        <AnchorNav
          class="faq__nav"
          :content="content.categories"
          @chosen-link="updateCategory"
        ></AnchorNav>

        <FlexibleFaq v-if="elements" :content="elements[0]"></FlexibleFaq>
      </div>
    </div>

    <BigCta :content="content.bigCta"></BigCta>
  </div>
</template>

<script lang="ts">
import type { Faq } from '@/types'
</script>

<script setup lang="ts">
import { ref } from 'vue'

import FlexibleFaq from '@/components/flexible/Faq.vue'
import AnchorNav from '@/components/global/AnchorNav.vue'
import BigCta from '@/components/global/BigCta.vue'
import HeroSingle from '@/components/hero/Single.vue'

// Props
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const elements = ref(props.content.categories)

const updateCategory = (category: string) => {
  const allDetails = document.querySelectorAll('.details')

  // Close all details
  allDetails.forEach((item, i) => {
    item.removeAttribute('open')
  })

  elements.value = props.content.categories.filter(
    (obj: Faq) => obj.slug === category.replace(/#/g, '')
  )
}
</script>

<style lang="scss" scoped>
.faq {
  padding-top: $header-height-mobile;

  @include mq(l) {
    padding-top: $header-height;
  }
}

.faq-inner {
  @include mq(m) {
    position: relative;
    display: flex;
  }
}

.faq__nav {
  width: 100%;

  :deep(.anchor-nav__link) {
    white-space: nowrap;
  }

  @include mq(m) {
    max-width: 26rem;
  }

  @include mq(xl) {
    position: absolute;
    top: 0;
    left: 0;
  }

  @include mq($until: m) {
    display: flex;
    gap: 2.4rem;
    flex-wrap: nowrap;
    overflow: auto;
    width: 90vw;
  }
}

:deep(.faq) {
  padding-top: 0;
}

:deep(.faq__title) {
  display: none;
}

:deep(.faq__content) {
  @include mq(m) {
    // max-width: calc(100% - 26rem);
  }

  @include mq(xl) {
    max-width: calc(100% - 52rem);
  }
}
</style>
